import { render, staticRenderFns } from "./AutomaticMoveOrder.vue?vue&type=template&id=33a2e4ff"
import script from "./AutomaticMoveOrder.vue?vue&type=script&lang=js"
export * from "./AutomaticMoveOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports